import './App.css';
import Contacts from './components/Contacts'

function App() {
  return (
    <div className="App">
      <Contacts />
    </div>
  );
}

export default App;
